import { ApiProperty } from "@nestjs/swagger";

export class UpdateCasesRequest{
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    reported: number;
    @ApiProperty()
    dispatch?: number;
    @ApiProperty()
    dispatchStatus?: string;
}